// © Microsoft Corporation. All rights reserved.

import { AccentButton, OutlineButton } from "@microsoft/fast-components-react-msft";
import { activity, pen } from "../../utils/icons";

import React from "react";
import { SocialProps } from "../../Social.props";
import { SocialState } from "../../Social.state";
import { UGContent } from "@msnews/social-data-service";
import UGContentCreateView1 from "../ug-content-create-view1/UGContentCreateView1";
import UGContentCreateView2 from "../ug-content-create-view2/UGContentCreateView2";
import { connect } from "react-redux";

const UGCreateSteps = {
    Step1: 0,
    Step2: 1
};

interface UGContentCreatePageProps extends SocialProps {
    ugContent: UGContent;
}

interface UGContentCreatePageState {
    currentStep: number;
}

const mapStateToProps = function(state: SocialState) {
    return {
        ugContent: state.ugContent
    };
};

class UGContentCreatePage extends React.Component<UGContentCreatePageProps, UGContentCreatePageState> {

    constructor(props) {
        super(props);

        this.state = {
            currentStep: UGCreateSteps.Step1
        };
    }

    componentDidMount() {
        this.props.ugContentConnector.fetchUGContent(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id != null && prevProps.id != this.props.id) {
            this.props.ugContentConnector && this.props.ugContentConnector.fetchUGContent(this.props.id);
        }
    }

    publishContent() {
        this.props.ugContentConnector.publishUGContent(this.props.ugContent.id);
    }

    unpublishContent() {
        this.props.ugContentConnector.unPublishUGContent(this.props.ugContent.id);
    }

    saveContent() {
        this.props.ugContentConnector.saveUGContent(this.props.ugContent);
    }

    showMyArticles(id) {
        this.props.popupConnector.openPopup("myArticles", {id});
    }

    showMyDrafts(id) {
        this.props.popupConnector.openPopup("myDrafts", {id});
    }

    updateSaveStatus(saveStatus) {
        this.setState({
            ...saveStatus
        });
    }

    render() {
        const { managedClasses, ugContent, ugContentConnector, t } = this.props;
        const { currentStep } = this.state;
        if (!ugContent) { return null; }

        let saveLabelName = "Save";
        if (ugContent.isSaving) {
            saveLabelName = "Saving..";
        } else if (!ugContent.isSaving && ugContent.id) {
            saveLabelName = "Saved";
        }

        const navButtons = (step) => {
            if (step == UGCreateSteps.Step1) {
                return <div className="cwt-nav-buttons">
                    <OutlineButton className="cwt-fast-button" onClick={this.saveContent.bind(this)}> {saveLabelName} </OutlineButton>
                    <AccentButton className="cwt-fast-button" onClick={this.nextStep.bind(this)}> {t.UGContentCreatePageNextButton} </AccentButton>
                </div>;
            } else if (step == UGCreateSteps.Step2) {
                return <div className="cwt-nav-buttons">
                    <OutlineButton className="cwt-fast-button" onClick={this.prevStep.bind(this)}> {t.UGContentCreatePagePreviousButton} </OutlineButton>
                    <OutlineButton className="cwt-fast-button" onClick={this.saveContent.bind(this)}> {saveLabelName} </OutlineButton>
                    {ugContent.isPublished ?
                        <AccentButton className="cwt-fast-button" onClick={this.unpublishContent.bind(this)}> {t.UGContentCreatePageUnPublishButton} </AccentButton> :
                        <AccentButton className="cwt-fast-button" onClick={this.publishContent.bind(this)}> {t.UGContentCreatePagePublishButton} </AccentButton>}
                </div>;
            }

            return "";
        };

        return (
            <div className={managedClasses.ugContentCreatePageContainer}>
                <header className="cwt-ugc-create-header">
                    <div className="cwt-header-buttons">
                        <ul className="cwt-tabs cwt-profile-tabs no-select cwt-section">
                            <li className={"cwt-tab-item"} onClick={this.showMyArticles.bind(this, ugContent && ugContent.id)}>
                                <i className="cwt-icon"> {activity} <span className="cwt-icon-label"> {t.UGContentCreatePageMyArticles} </span> </i>
                            </li>
                            <li className={"cwt-tab-item"} onClick={this.showMyDrafts.bind(this, ugContent && ugContent.id)}>
                                <i className="cwt-icon"> {pen} <span className="cwt-icon-label"> {t.UGContentCreatePageMyDraft} </span> </i>
                            </li>
                        </ul>
                    </div>
                    {navButtons(currentStep)}
                </header>

                { currentStep == UGCreateSteps.Step1
                    ? <UGContentCreateView1 {...{managedClasses, ugContent, ugContentConnector, t}}/>
                    : <UGContentCreateView2 {...{managedClasses, ugContent, ugContentConnector, t}}/>
                }
            </div>
        );
    }

    nextStep() {
        this.setState({
            currentStep: Math.min(Object.keys(UGCreateSteps).length -1, this.state.currentStep+1)
        });
    }

    prevStep() {
        this.setState({
            currentStep: Math.max(0, this.state.currentStep-1)
        });
    }
}
export default connect(mapStateToProps)(UGContentCreatePage);
